import { useContext } from "react";
import { ShopContext } from "../../contexts";

export function useProtectionProducts() {
  const { protectionProducts } = useContext(ShopContext);
  
  return protectionProducts
}